/**
 * Tirer-pour-rafraîchir : la DÉCISION est pure (testable), le composant ne fait
 * que la jouer. Un geste ne compte que s'il part du HAUT de la zone (sinon on
 * volerait le défilement) et qu'il descend franchement.
 */

/** Distance à tirer pour déclencher le rechargement. */
export const PULL_THRESHOLD_PX = 70;
/** Distance maximale de l'indicateur (effet élastique). */
export const PULL_MAX_PX = 110;

export interface PullState {
  /** Décalage à appliquer à l'indicateur (0 = rien à l'écran). */
  offset: number;
  /** Le seuil est franchi : relâcher déclenche le rechargement. */
  armed: boolean;
}

/**
 * Le geste peut-il commencer ? Seulement si la zone est tout en haut et que
 * rien n'est déjà en cours.
 */
export function canStartPull(scrollTop: number, isRefreshing: boolean): boolean {
  return scrollTop <= 0 && !isRefreshing;
}

/**
 * Où en est le geste après un déplacement vertical de `dy` pixels
 * (positif = vers le bas). Résistance : au-delà du seuil, l'indicateur
 * n'avance plus qu'au tiers — on sent qu'on tire sur un élastique.
 */
export function pullState(dy: number): PullState {
  if (dy <= 0) return { offset: 0, armed: false };
  const eased =
    dy <= PULL_THRESHOLD_PX
      ? dy
      : PULL_THRESHOLD_PX + Math.min((dy - PULL_THRESHOLD_PX) / 3, PULL_MAX_PX - PULL_THRESHOLD_PX);
  return { offset: Math.min(eased, PULL_MAX_PX), armed: dy >= PULL_THRESHOLD_PX };
}

/** Relâcher à cette distance déclenche-t-il le rechargement ? */
export function shouldRefreshOnRelease(dy: number): boolean {
  return pullState(dy).armed;
}
